import React from 'react';

export const pictureOf = (employee) =>
  employee?.picture ||
  employee?.google_picture ||
  employee?.google_picture_url ||
  employee?.photo_url ||
  employee?.avatar ||
  employee?.image ||
  null;

export const Avatar = ({ employee, size = 32, onClick, title }) => {
  const label = title || employee?.name || 'Personne';
  const picture = pictureOf(employee);
  const className = `shrink-0 rounded-full bg-indigo-500 text-white flex items-center justify-center overflow-hidden border-0 p-0 ${
    onClick ? 'cursor-pointer hover:ring-2 hover:ring-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-300' : ''
  }`;
  const content = picture ? (
    <img src={picture} alt={label} className="w-full h-full object-cover" />
  ) : (
    <span className="font-semibold" style={{ fontSize: Math.max(10, size * 0.38) }}>
      {employee?.name?.charAt(0) || '?'}
    </span>
  );
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={className} style={{ width: size, height: size }} title={label} aria-label={label}>
        {content}
      </button>
    );
  }
  return (
    <div className={className} style={{ width: size, height: size }} title={label}>
      {content}
    </div>
  );
};

/** Bloc de la fiche : titre discret, action à droite, aide facultative sous le titre. */
export const Section = ({ title, action, hint, children, className = '' }) => (
  <section className={className}>
    <div className="flex items-center justify-between gap-2 mb-1.5">
      <h3 className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider">{title}</h3>
      {action}
    </div>
    {hint && <p className="text-xs text-slate-400 mb-2">{hint}</p>}
    {children}
  </section>
);

export const LinkButton = ({ children, onClick, disabled, title }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    title={title}
    className="text-xs font-medium text-indigo-600 hover:text-indigo-800 disabled:opacity-50"
  >
    {children}
  </button>
);

export const Bullets = ({ items, color = 'bg-slate-400', render = (item) => item, empty }) =>
  items && items.length > 0 ? (
    <ul className="space-y-1.5">
      {items.map((item, index) => (
        <li key={`${index}-${String(item).slice(0, 24)}`} className="flex items-start gap-2 text-sm text-slate-700">
          <span className={`mt-[7px] w-1.5 h-1.5 rounded-full shrink-0 ${color}`} />
          <span className="min-w-0">{render(item)}</span>
        </li>
      ))}
    </ul>
  ) : (
    <p className="text-sm text-slate-400">{empty}</p>
  );

export const errorMessage = async (response, fallback) => {
  try {
    const data = await response.json();
    if (typeof data?.detail === 'string') return data.detail;
  } catch {
    // réponse sans JSON
  }
  return fallback;
};
